'use client';

import { FunctionComponent } from 'react';
import { useTranslate } from '@xFrame4/components/Hooks';
import ALink from '@xFrame4/components/next/ALink';
import UrlHelper from 'frontend_business/seo/UrlHelper';

export interface PaymentContactSupportProps
{
    language: string;
}

/**
 * Component: Common contact support section for payment pages.
 */
const PaymentContactSupport: FunctionComponent<PaymentContactSupportProps> = (props) =>
{
    const t = useTranslate();
    
    /** Render */
    return (
        <div className="text-center mt-4">
            <p className="text-muted">
                {t('NEED_HELP', props.language)}
                <br />
                <ALink
                    href={UrlHelper.instance.getContactUrl(props.language)}
                    className="text-decoration-none"
                    target="_blank"
                >
                    {t('CONTACT_SUPPORT', props.language)}
                </ALink>
            </p>
        </div>
    );
}

export default PaymentContactSupport;